module.exports = __webpack_public_path__ + "img/wornOutTools.4a0eb8cd.webp";